import { Tab } from '@headlessui/react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function Tabs({ tabs, className, panelClassName }) {
  return (
    <Tab.Group>
      <Tab.List
        className={twMerge(
          'flex flex-wrap gap-2 border-b border-gray-200 pb-4',
          className
        )}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) =>
              clsx(
                'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg',
                'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
                'transition-colors duration-200',
                selected
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              )
            }
          >
            {tab.icon && <tab.icon className="h-5 w-5" />}
            <span className="hidden sm:inline">{tab.name}</span>
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className={twMerge('mt-4', panelClassName)}>
        {tabs.map((tab) => (
          <Tab.Panel key={tab.name}>{tab.component}</Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
}

export function TabList({ children, className }) {
  return (
    <Tab.List
      className={twMerge(
        'flex flex-wrap gap-2 border-b border-gray-200 pb-4',
        className
      )}
    >
      {children}
    </Tab.List>
  );
}

export const TabItem = ({ children, icon: Icon, className }) => {
  return (
    <Tab
      className={({ selected }) =>
        twMerge(
          clsx(
            'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg',
            'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
            'transition-colors duration-200',
            selected
              ? 'bg-primary-100 text-primary-700'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
          ),
          className
        )
      }
    >
      {Icon && <Icon className="h-5 w-5" />}
      {children}
    </Tab>
  );
};

export const TabPanels = ({ children, className }) => {
  return (
    <Tab.Panels className={twMerge('mt-4', className)}>{children}</Tab.Panels>
  );
};

export const TabPanel = ({ children, className }) => {
  return <Tab.Panel className={className}>{children}</Tab.Panel>;
};

export default Tabs;
